import { render, staticRenderFns } from "./TelnyxChannelDetail.vue?vue&type=template&id=57929bd8&scoped=true"
import script from "./TelnyxChannelDetail.vue?vue&type=script&lang=js"
export * from "./TelnyxChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./TelnyxChannelDetail.vue?vue&type=style&index=0&id=57929bd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57929bd8",
  null
  
)

export default component.exports